import Routes from "./Routes";

function Index() {
  return <Routes />;
}

export default Index;
